import { render, staticRenderFns } from "./EstateCode.vue?vue&type=template&id=072fd5b6&"
import script from "./EstateCode.vue?vue&type=script&lang=js&"
export * from "./EstateCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports